module.exports = __webpack_public_path__ + "img/test_barcode_white.d158dfb1.svg";